export const SET_INFO = 'V2/CUSTOMER_SET_INFO'
export function setInfo(id, info) {
  return {
    type: SET_INFO,
    id: id,
    info: info
  };
}
export const UPDATE_INFO = 'update customer info'
export function updateInfo(id, key, value) {
  return {
    type: UPDATE_INFO,
    id: id,
    key: key,
    value: value
  };
}

export const CREATE_TAG_SUCCESS = 'customer successfully create a tag'
export function createTagSuccess(id, tags) {
  return {
    type: CREATE_TAG_SUCCESS,
    id: id,
    tags: tags
  };
}

export const DELETE_TAG_SUCCESS = 'customer sucessfully delete a tag'
export function deleteTagSuccess(id, tags) {
  return {
    type: DELETE_TAG_SUCCESS,
    id: id,
    tags: tags
  };
}

export const UPDATE_TO_DB_SUCCESS = 'V2/CUSTOMER_UPDATE_TO_DB_SUCCESS'
export function updateToDBSuccess(id, info) {
  return {
    type: UPDATE_TO_DB_SUCCESS,
    id: id,
    info: info,
  };
}


export const READ_TICKETS_FROM_DB_REQUEST= 'V2/CUSTOMER_READ_TICKETS_FROM_DB_REQUEST'
export function readResolvedTicketsFromDBRequest(id) {
  return {
    type: READ_TICKETS_FROM_DB_REQUEST,
    id: id
  };
}
export const READ_TICKETS_FROM_DB_SUCCESS = 'V2/CUSTOMER_READ_TICKETS_FROM_DB_SUCCESS'
export function readResolvedTicketsFromDBSuccess(id, tickets) {
  return {
    type: READ_TICKETS_FROM_DB_SUCCESS,
    id: id,
    tickets: tickets,
  };
}

export const READ_STATS_FROM_DB_REQUEST= 'V2/CUSTOMER_READ_STATS_FROM_DB_REQUEST'
export function readStatsFromDBRequest(id) {
  return {
    type: READ_STATS_FROM_DB_REQUEST,
    id: id
  };
}
export const READ_STATS_FROM_DB_SUCCESS = 'V2/CUSTOMER_READ_STATS_FROM_DB_SUCCESS'
export function readStatsFromDBSuccess(id, stats) {
  return {
    type: READ_STATS_FROM_DB_SUCCESS,
    id: id,
    stats: stats,
  };
}
export const READ_STATS_FROM_DB_FAILURE = 'V2/CUSTOMER_READ_STATS_FROM_DB_FAILURE'
export function readStatsFromDBFailure(id, stats) {
  return {
    type: READ_STATS_FROM_DB_FAILURE,
    id: id,
    stats: stats,
  };
}



export const IS_ONLINE = 'V2/CUSTOMER_IS_ONLINE'
export function isOnline(id) {
  return {
    type: IS_ONLINE,
    id: id,
  };
}
export const IS_OFFLINE = 'V2/CUSTOMER_IS_OFFLINE'
export function isOffline(id) {
  return {
    type: IS_OFFLINE,
    id: id,
  };
}
export const PUTS = 'V2/CUSTOMERS_PUT'
export function puts(customers) {
  return {
    type: PUTS,
    customers: customers
  };
}



// WEBPACK FOOTER //
// ./src/model/Customer/actions.js